// src/components/ScrollToHash/ScrollToHash.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToHash({ yOffset = -50 }) {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");

    const scrollToElement = () => {
      const element = document.getElementById(id);

      if (!element) return;

      const yPosition =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: yPosition,
        behavior: "smooth"
      });
    };

    // Ensimmäinen yritys heti route-vaihdon jälkeen
    scrollToElement();

    // Uusintayritykset, koska React-sisältö, kuvat, fontit tai kalenteri
    // voivat muuttaa sivun korkeutta hetki navigoinnin jälkeen.
    const timeouts = [
      window.setTimeout(scrollToElement, 100),
      window.setTimeout(scrollToElement, 300),
      window.setTimeout(scrollToElement, 600)
    ];

    return () => {
      timeouts.forEach((timeoutId) => window.clearTimeout(timeoutId));
    };
  }, [location.pathname, location.hash, yOffset]);

  return null;
}

export default ScrollToHash;